module.exports = __webpack_public_path__ + "static/media/SmartShop_1-595w.bd84517a.png";